import React, { useState } from 'react';
import { BottomSheet } from '../common/BottomSheet';
const dims = {
  '国家/地区': ['英国', '美国', '中国香港', '新加坡', '澳大利亚', '加拿大'],
  学历: ['本科', '硕士', '博士'],
  专业: ['计算机', '商科', '工程', '艺术', '社科', '理科'],
  排名: ['Top 10', 'Top 30', 'Top 50', 'Top 100'],
  申请难度: ['容易', '中等', '困难'],
  学费区间: ['<20万/年', '20-40万/年', '40万+/年']
};
export type Filters = Record<string, string[]>;
export function FilterSheet({
  open,
  onClose,
  value,
  onApply
}: {
  open: boolean;
  onClose: () => void;
  value: Filters;
  onApply: (v: Filters) => void;
}) {
  const [draft, setDraft] = useState<Filters>(value);
  const toggle = (k: string, v: string) => {
    const arr = draft[k] || [];
    setDraft({
      ...draft,
      [k]: arr.includes(v) ? arr.filter(x => x !== v) : [...arr, v]
    });
  };
  return <BottomSheet open={open} onClose={onClose} title="筛选" maxHeight="85vh" data-id="element-148">
      <div className="p-4 space-y-4 pb-2" data-id="element-149">
        {Object.entries(dims).map(([k, opts]) => <div key={k} data-id="element-150">
            <div className="text-sm font-semibold text-slate-800 mb-2" data-id="element-151">{k}</div>
            <div className="flex flex-wrap gap-2" data-id="element-152">
              {opts.map(o => {
            const sel = (draft[k] || []).includes(o);
            return <button key={o} onClick={() => toggle(k, o)} className={`px-3 py-1.5 rounded-full text-xs border transition ${sel ? 'bg-blue-600 text-white border-blue-600' : 'bg-slate-50 text-slate-700 border-slate-200'}`} data-id="element-153">
                    {o}
                  </button>;
          })}
            </div>
          </div>)}
      </div>
      <div className="sticky bottom-0 bg-white border-t border-slate-100 p-3 flex gap-2" data-id="element-154">
        <button onClick={() => setDraft({})} className="flex-1 h-11 rounded-full border border-slate-300 text-slate-700 font-semibold text-sm" data-id="element-155">
          重置
        </button>
        <button onClick={() => {
        onApply(draft);
        onClose();
      }} className="flex-1 h-11 rounded-full bg-blue-600 text-white font-semibold text-sm" data-id="element-156">
          应用筛选
        </button>
      </div>
    </BottomSheet>;
}